import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to disable browser back and forward buttons
 * Enhanced version for production/staging environments
 */
const useDisableBrowserNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    // Ensure we're in a browser environment
    if (typeof window === 'undefined') return;

    // Clear any existing history state
    if (window.history.state === null) {
      window.history.replaceState({ navigationDisabled: true }, '', window.location.href);
    }

    // Push initial state to create history entry
    window.history.pushState({ navigationDisabled: true }, '', window.location.href);
    
    // Handle popstate event (triggered by back/forward buttons)
    const handlePopState = (event) => {
      // Prevent default if possible
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      
      // Push the current state back to maintain the current page
      window.history.pushState({ navigationDisabled: true }, '', window.location.href);
      
      // Log for debugging
      console.log("Browser navigation is disabled. Please use in-app navigation.");

    };

    // Handle beforeunload as backup
    const handleBeforeUnload = (event) => {
      // This won't prevent back/forward but helps with debugging
      console.log("Navigation attempt detected");
    };

    // Add event listeners
    window.addEventListener('popstate', handlePopState, { capture: true });
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Additional: Prevent hash changes
    const handleHashChange = (event) => {
      event.preventDefault();
      window.history.pushState({ navigationDisabled: true }, '', window.location.href);
    };
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup function to remove event listeners
    return () => {
      window.removeEventListener('popstate', handlePopState, { capture: true });
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location.pathname]); // Re-run when route changes
};

export default useDisableBrowserNavigation;